import { getTranslation, getTranslationArray } from '../utils/translations';

const useTranslation = () => {
  const language = process.env.GATSBY_LANGUAGE || 'en';

  const t = (key: string): string => getTranslation(language, key);

  const tArray = <T = string>(key: string): T[] =>
    getTranslationArray<T>(language, key);

  return { t, tArray, language };
};

export default useTranslation;
